<template>
    <div class="cancelPage-agreement-component">
      <div class="title">
        <van-nav-bar
          title="用户注销"
          left-arrow
          @click-left="onClickLeft"
          fixed
        />
      </div>
      <div class="warn-wrap">
        <van-image
          round
          width="1rem"
          height="1rem"
          :src="require('../../icons/cancel-acount-warn.png')"
        />
      </div>
      <p class="cancel-page-acount">将<span>{{ mobileNum }}</span>所绑定的账号注销</p>
      <p class="no-text-indent no-text-indent-another">
        注销后，您在荷叶健康上的相关服务、信息将被清空，且无法找回，具体包括：
      </p>
      <p class="no-text-indent">
        • 您将无法再次登录荷叶健康网站、APP等
      </p>
      <p class="no-text-indent">
        • 您将无法进行依赖于账号权限进行的其他操作
      </p>
      <p class="no-text-indent">
        • 您将无法找回该账号下的个人信息、交易记录、业务数据、历史信息等
      </p>
      <p class="no-text-indent no-text-indent-another">
        请确保所有交易完结且无纠纷，账号注销后的历史交易可能产生的资金等视作自动放弃。
      </p>
      <div class="bottom-wrap">
        <div>点击【申请注销】即代表您已同意<span class="cancel-acount-agreement" @click="jumpAgreement">《用户注销协议》</span></div>
        <div class="cancel-btn">
          <van-button round type="primary" disabled v-if="btndisable" block color="#C6CAD4">{{ getCode }}</van-button>
          <van-button round type="primary" v-if="!btndisable" block @click="applyCancel">{{ getCode }}</van-button>
        </div>
      </div>
      <van-dialog v-model="dialogShow" confirm-button-text="联系客服" confirm-button-color="black" cancel-button-text="再想想" cancel-button-color="#00B955" show-cancel-button @confirm="sure">
        <p class="sure-wrap">请您务必使用账号关联的手机号拨打客服电话确认注销账号，其它手机号拨打电话无法注销。</p>
      </van-dialog>
    </div>
  </template>
  <script>
  export default {
    data() {
      return {
        isShow: false,
        tmpNum: "",
        mobileNum: "",
        dialogShow: false,
        btndisable: true,
        count: 10,
        getCode: "申请注销（10s）",
      };
    },
    created() {
       if (this.$route.query['tel']) {
        this.tmpNum = this.$route.query['tel'];
        this.mobileNum = this.mobileStr(this.$route.query['tel']+'');
      } else {
        this.mobileNum = "";
      }
    },
    mounted(){
      this.getVerifyCode();
      //this.mobileNum = this.mobileStr("130****4540");
      //this.mobileNum = this.mobileStr(18310396867+"");
      //console.log("手机号脱敏后",this.mobileNum);
    },
    activated(){
  
    },
    watch: {
      '$route.query.isShow':() =>{
         
      }
    },
  
    methods: {
      mobileStr(str) {
        if(str.length>7){
          return str.substring(0,3)+'****'+str.substring(7,str.length);
        }else {
          return str.substring(0,str.length-1)+'****';
        }
      },
      sure() {
        this.call();
      },
      call() {
        // window.location.href = "protocol://action/tel";
        window.location.href = "protocol://action/tel?tel=4000507788";
      },
      onClickLeft() {
        window.location.href = "protocol://action/finish";
        //window.location.href = "protocol://action/rx_history_back";
      },
      applyCancel() {
        this.dialogShow = true;
      },
      jumpAgreement() {
        this.$router.push("/cancelAccount/userServiceAgreement");
      },
      getVerifyCode(){
          var countDown = setInterval(()=>{
            if(this.count < 1){
              this.btndisable = false;
              this.getCode = '申请注销';
              this.count = 9;
              clearInterval(countDown);
            }else{
              this.btndisable = true; //申请注销（10s）
              this.getCode = '申请注销（' + this.count-- + 's）';
            }
          },1000);
        }
    },
  
  };
  </script>
  
  <style scoped lang="scss">
  .cancelPage-agreement-component {
    margin-top: 20px;
    font-size: 14px;
    padding: 0 20px 10px;
    h3 {
      text-align: center;
    }
    .title {
      margin: 10px 0;
    }
    p {
      text-indent: 2em;
      margin: 2px 0;
    }
    .warn-wrap {
      display: flex;
      justify-content: center;
      margin: 0.48rem 0;
      margin-top:1.6rem;
    }
    .cancel-page-acount {
      text-indent: 0;
      text-align: center;
    }
    .no-text-indent {
      text-indent: 0;
    }
    .no-text-indent-another {
      margin-top: 0.48rem;
      margin-bottom: 0.48rem;
    }
    .bottom-wrap {
      width: 90%;
      position: absolute;
      bottom: 20px;
      text-align: center;
    }
    .cancel-acount-agreement {
      color: #07c160;
      cursor: pointer;
    }
    .cancel-btn {
      position: relative;
      width: 100%;
      margin-top: 0.24rem;
    }
    .sure-wrap {
      padding: 0 20px;
      margin: 0.8rem 0;
      text-align: center;
      text-indent: 0;
    }
  }
  /deep/ .van-nav-bar__text {
    color: #333;
  }
  /deep/ .van-nav-bar .van-icon {
    color: #333;
  }
  </style>